// Default value for the key where the Split piece of state is expected to be mounted.
export var DEFAULT_SPLIT_STATE_SLICE = 'splitio';
export var VERSION = 'redux-' + '1.7.3';
// Treatments
export var ON = 'on';
export var OFF = 'off';
export var CONTROL = 'control'; // SplitIO's default value
export var CONTROL_WITH_CONFIG = {
    treatment: 'control',
    config: null,
};
export var getControlTreatmentsWithConfig = function (featureFlagNames) {
    return featureFlagNames.reduce(function (pValue, cValue) {
        pValue[cValue] = CONTROL_WITH_CONFIG;
        return pValue;
    }, {});
};
// Action types
export var SPLIT_READY = 'SPLIT_READY';
export var SPLIT_READY_WITH_EVALUATIONS = 'SPLIT_READY_WITH_EVALUATIONS';
export var SPLIT_READY_FROM_CACHE = 'SPLIT_READY_FROM_CACHE';
export var SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS = 'SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS';
export var SPLIT_UPDATE = 'SPLIT_UPDATE';
export var SPLIT_UPDATE_WITH_EVALUATIONS = 'SPLIT_UPDATE_WITH_EVALUATIONS';
export var SPLIT_TIMEDOUT = 'SPLIT_TIMEDOUT';
export var SPLIT_DESTROY = 'SPLIT_DESTROY';
export var ADD_TREATMENTS = 'ADD_TREATMENTS';
// Warning and error messages
export var ERROR_GETT_NO_INITSPLITSDK = '[Error] To use "getTreatments" the SDK must be first initialized with a "initSplitSdk" action';
export var ERROR_DESTROY_NO_INITSPLITSDK = '[Error] To use "destroySplitSdk" the SDK must be first initialized with a "initSplitSdk" action';
export var ERROR_TRACK_NO_INITSPLITSDK = '[Error] To use "track" the SDK must be first initialized with an "initSplitSdk" action';
export var ERROR_MANAGER_NO_INITSPLITSDK = '[Error] To use the manager, the SDK must be first initialized with an "initSplitSdk" action';
export var ERROR_SELECTOR_NO_SPLITSTATE = '[Error] When using selectors, "splitState" value must be a proper splitio piece of state';
